import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../Logo/Logo";
import "./LandingPage.scss";

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="LandingPage">
      <a
        href="https://blueprintnyc.com"
        target="_blank"
        rel="noopener noreferrer"
        className="LandingPage__logo"
      >
        <Logo client="blueprint" from="landing" />
      </a>
      <div className="LandingPage__content">
        <h3>Connections Game</h3>

        <div className="LandingPage__status">
          <p>
            This is a word association game where you find groups of four words
            that share a connection. Each game exists at its own URL path. If
            you run into any issues, please contact support@blueprintnyc.com.
          </p>
        </div>

        {/* <div className="LandingPage__actions">
          <button
            className="btn btn-primary"
            onClick={() => navigate("/admin")}
          >
            Admin Dashboard
          </button>
          <p className="LandingPage__note">
            Access the admin dashboard to create and manage games.
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default LandingPage;
